import { createSlice } from '@reduxjs/toolkit';

const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState: {
    /** @type {null | { label: string, path?: string }[]} */
    items: null,
  },
  reducers: {
    setPageBreadcrumbTrail(state, { payload }) {
      state.items = Array.isArray(payload) ? payload : null;
    },
    clearPageBreadcrumbTrail(state) {
      state.items = null;
    },
  },
});

export const { setPageBreadcrumbTrail, clearPageBreadcrumbTrail } = breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;
